<script>
import '../../assets/scss/frontend/footer.scss'
export default {
  name: "FooterLayout"
}

</script>

<template>
  <footer id="footer__map">
    <div className="left-content">
      <div className="logo">
        <img src="../../../src/assets/images/logo.svg" alt="">
      </div>
      <ul>
        <li>
          <a href="#">IBRD</a>
        </li>
        <li>
          <a href="#">IBRD</a>
        </li>
        <li>
          <a href="#">IBRD</a>
        </li>
        <li>
          <a href="#">IBRD</a>
        </li>
      </ul>
    </div>
    <div className="copyright">
      © 2023 The World Bank Group, All Rights Reserved
    </div>
  </footer>

</template>